import { Stack, Typography, Button } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import EmptyData from '../../../../assets/images/empty-data-image.svg';

export const EmptyCustomersPageContent: React.FC = () => {
  return (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      sx={{ height: '100%' }}
    >
      <img
        src={EmptyData}
        alt="Empty Data"
        width={400}
        height={400}
      />
      <Typography variant="h5">Customers Will Show Up Here</Typography>
      <Typography 
        variant="body1" 
        sx={{ color: '#666' }} 
      >
        You haven’t created any customers yet. Start by adding your first one below.
      </Typography>
      <Button
        variant="contained"
        size="large"
        component={NavLink}
        to="create"
      >
        Create Your First Customer
      </Button>
    </Stack>
  );
};